import { Container, Row, Col } from "react-bootstrap";

export default function ContentPage({ embedded = false }) {
  const Wrapper = ({ children }) =>
    embedded ? (
      <div className="p-3">{children}</div>
    ) : (
      <div className="container py-5">
        <div className="row justify-content-center">
          <div className="col-lg-10 col-xl-8">
            <div className="p-5 rounded shadow-sm">{children}</div>
          </div>
        </div>
      </div>
    );
  return (
    // <Container className="py-5">
    //   <Row className="justify-content-center">
    //     <Col lg={10} xl={8}>
    //       <div className="p-5 rounded shadow-sm">
    <Wrapper>
      {/* Page Title */}
      <div className="section-title mb-4">
        <h1 style={{ fontSize: "30px" }}>Navitas Credit Policy Overview</h1>
      </div>

      {/* Intro */}
      <section className="mb-5">
        <p>
          Navitas Credit Corp. (“Navitas”) provides financing to small and
          medium sized companies (“borrowers”) so that they may acquire the
          equipment they need for use in their business. Borrowers are
          originated by Navitas through two primary sales channels:
        </p>
        <ul className="ms-4">
          <li className="mb-2">
            <strong>Direct Originations</strong> – solicit on-going customer
            referrals from National Strategic Accounts, equipment vendor
            relationships, and direct from borrowers / lessees.
          </li>
          <li>
            <strong>Indirect Originations</strong> – referrals and assignments
            from independent brokers and lessors through our Partner Funding
            division.
          </li>
        </ul>
        <p>
          Navitas’ credit policies provide consistent underwriting criteria to
          enable sound investment decisions to credit worthy borrowers in a
          timely manner. Navitas utilizes expert judgmental review in
          conjunction with quantitative credit scoring grids to identify
          acceptable and non-acceptable credits. The process for making credit
          decisions is based on the receipt of sufficient information to
          evaluate the credit, an understanding of the current markets,
          geographical location and financial conditions of the applicant. It
          should be noted that based on the average ticket size, most credit
          decisions are made “App Only” and do not require financial statements.
          Navitas uses third party data sources to validate the information
          received from each applicant prior to rendering a decision. Any
          exceptions to standard credit policy are coded within LeaseWorks.
        </p>
        <p>
          Navitas is a general equipment leasing/financing company. Transactions
          are typically sourced through vendors and intermediaries for their
          customers. Equipment needs can be extremely varied; therefore, Navitas
          looks towards positive attributes of a customer’s ability and
          willingness to meet the obligation. In many cases, the equipment can
          have limited or no resale value. It is essential that a customer
          demonstrates strong character and the ability to meet its financial
          obligations.
        </p>
        <p>
          Navitas identifies transactions that meet its credit risk profile
          while referring certain transactions to third party funding sources.
          Navitas may refertransactions due to borrower exposure or credit
          quality. This basic approach allows Navitasto maintain a strong risk
          discipline through its diverse borrower, source, equipment, and
          referral base while developing strong relationships with third party
          funding sources to meet our customers’ needs.
        </p>
      </section>

      {/* Compliance */}
      <section className="mb-5">
        <div className="section-title">
          <h2>Compliance Practices</h2>
        </div>
        <p>
          Navitas’ credit policies have been developed in accordance with
          various regulatory rules and guidelines that may apply to certain
          aspects of our business and are designed to fit within the greater
          compliance program of United Community Bank, Inc. When appropriate,
          specific compliance practices are referenced within the applicable
          credit policies in this manual. More expansive general policy
          statements and practices are detailed within the Navitas Compliance
          Policies & Procedures Manual. These policies include, but are not
          limited to, our Customer Identification Program (CIP), AML/BSA, Fair
          Lending (FCRA/ECOA), ESIGN – UETA, CAN-SPAM, SCRA, and TCPA policies
          and practices.
        </p>
      </section>

      {/* Committee */}
      <section className="mb-5">
        <div className="section-title mb-4">
          <h1 style={{ fontSize: "30px" }}>Credit Committee</h1>
        </div>
        <p>
          The Navitas Credit Committee is chaired by the Navitas Chief Credit
          Officer (“CCO”) and consists of the CEO, CCO, and invited
          participants. The Committee has the authority to set, oversee and
          adapt credit policies, review larger charge-offs quarterly, and
          convenes a quarterly Asset Quality Review.
        </p>
      </section>

      {/* Authority Levels */}
      <section className="mb-5">
        <div className="section-title">
          <h2>Approval Authority Levels</h2>
        </div>
        <p>
          Credit approval authorities are established by the Navitas Credit
          Committee and delegated accordingly based on each individual’s level
          of experience. Approval authorities will be reviewed annually
        </p>
        <p>
          Credit approval authorities are based on Navitas’s total aggregate
          exposure to any one borrower or guarantor. The Navitas Credit
          Committee reviews as needed the individual authority levels of each
          officer and credit analyst and the authority levels required for an
          individual to sign transactional documents.
        </p>
        <p>
          Each individual will be granted an individual level of credit
          authority
        </p>
      </section>

      {/* Allowance Rule */}
      <section>
        <div className="section-title">
          <h2>10% Allowance Rule</h2>
        </div>
        <p>
          Each approval will be allowed a 10% allowance over and above an
          authorized approval to facilitate the booking oftransactions. The 10%
          rule is intended to assist with modifications during the final booking
          of a transaction to accommodate taxes financed or slight modifications
          in the final equipment configuration.
        </p>
      </section>
      {/* </div>
        </Col>
      </Row>
    </Container> */}
    </Wrapper>
  );
}
